import CarouselContainer from './CarouselContainer';
import CarouselItem from './CarouselItem';
import CarouselNext from './CarouselNext';
import CarouselPrevious from './CarouselPrevious';
import CarouselViewport from './CarouselViewport';
import CarouselWrapper from './CarouselWrapper';

export { useCarousel } from './useCarousel';

export const Carousel = Object.assign(CarouselWrapper, {
  Viewport: CarouselViewport,
  Container: CarouselContainer,
  Previous: CarouselPrevious,
  Item: CarouselItem,
  Next: CarouselNext,
});
